var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Checkbox"
  }, [_c('div', {
    staticClass: "Checkbox-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "js-actions-button Checkbox-input",
    class: {
      'Checkbox-input--checked': _vm.currentValue && !_vm.disabled,
      'Checkbox-input--hoverable': !_vm.disabled,
      'Checkbox-input--disabled': _vm.disabled
    },
    attrs: {
      "id": _vm.getCheckboxId,
      "aria-checked": _vm.currentValue,
      "disabled": _vm.disabled,
      "tabindex": _vm.globalTabIndex,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.currentValue,
      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, _vm.currentValue) > -1 : _vm.currentValue
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.currentValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.currentValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.currentValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.currentValue = $$c;
        }
      }
    }
  }), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "Checkbox-icon common-check",
    attrs: {
      "for": _vm.getCheckboxId
    }
  }), _vm.label ? _c('label', {
    staticClass: "Checkbox-label",
    attrs: {
      "for": _vm.getCheckboxId
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }